import svg4everybody from 'svg4everybody';
import $ from 'jquery';

svg4everybody();
window.$ = $;
window.jQuery = $;

require('slick-carousel');
require('masonry-layout/dist/masonry.pkgd');
require('imagesloaded');
require('video.js');


// WEBPACK FOOTER //
// ./src/js/vendor.js